import React from 'react';
import styles from './BtnPermitActions.module.scss';
import { useModal, modalType } from '../../modalProvider';
import { ReactComponent as EditNewIcon } from '../../../../../resource/EditNewIcon.svg';
import RoundedButton from '../../../../../components/RoundedButton/RoundedButton';
import cn from 'classnames';

const cancelledStatus = 5; // Аннулирован

const BtnPermitActions = ({ renderItem, permit, onSuccess }) => {
  const { open } = useModal(modalType.PERMIT_FORM);
  const isDisabled = permit?.permitStatus?.id === cancelledStatus;

  const handleClick = (e) => {
    e.stopPropagation();

    if (!!permit?.id) {
      open({ id: permit?.id, onSuccess });
      return;
    }

    open({ onSuccess });
  };


  if (typeof renderItem === 'function')
    return renderItem({ onClick: handleClick });

  return (
    <RoundedButton
      onClick={handleClick}
      text={<EditNewIcon />}
      type="link"
      disabled={isDisabled}
      className={cn(styles.btnEdit, {
        [styles.disabledBtn]: isDisabled,
      })}
    />
  );
};

export default BtnPermitActions;
